<template>
<div class="chapter">
<div class="inner_page">
<h2 class="toc">CONTENTS</h2>
<p class="toc"><a href="#/Text/Section0003">CHAPTER 1. THE COUNCIL OF WAYS AND MEANS</a></p>
<p class="toc"><a href="#/Text/Section0004">CHAPTER 2. DIGGING FOR TREASURE</a></p>
<p class="toc"><a href="#/Text/Section0005">CHAPTER 3. BEING DETECTIVES</a></p>
<p class="toc"><span href="#/Text/Section0006" title="Link target outside of Sample">CHAPTER 4. GOOD HUNTING</span></p>
<p class="toc"><span href="#/Text/Section0007" title="Link target outside of Sample">CHAPTER 5. THE POET AND THE EDITOR</span></p>
<p class="toc"><span href="#/Text/Section0008" title="Link target outside of Sample">CHAPTER 6. NOEL’S PRINCESS</span></p>
<p class="toc"><span href="#/Text/Section0009" title="Link target outside of Sample">CHAPTER 7. BEING BANDITS</span></p>
<p class="toc"><span href="#/Text/Section0010" title="Link target outside of Sample">CHAPTER 8. BEING EDITORS</span></p>
<p class="toc"><span href="#/Text/Section0011" title="Link target outside of Sample">CHAPTER 9. THE G. B.</span></p>
<p class="toc"><span href="#/Text/Section0012" title="Link target outside of Sample">CHAPTER 10. LORD TOTTENHAM</span></p>
<p class="toc"><span href="#/Text/Section0013" title="Link target outside of Sample">CHAPTER 11. CASTILIAN AMOROSO</span></p>
<p class="toc"><span href="#/Text/Section0014" title="Link target outside of Sample">CHAPTER 12. THE NOBLENESS OF OSWALD</span></p>
<p class="toc"><span href="#/Text/Section0015" title="Link target outside of Sample">CHAPTER 13. THE ROBBER AND THE BURGLAR</span></p>
<p class="toc"><span href="#/Text/Section0016" title="Link target outside of Sample">CHAPTER 14. THE DIVINING-ROD</span></p>
<p class="toc"><span href="#/Text/Section0017" title="Link target outside of Sample">CHAPTER 15. ‘LO, THE POOR INDIAN!’</span></p>
<p class="toc"><span href="#/Text/Section0018" title="Link target outside of Sample">CHAPTER 16. THE END OF THE TREASURE-SEEKING</span></p>
<p class="calibre1">
<a id="link2HCH0001"></a></p>
<div class="calibre9" id="calibre_pb_1"></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?23ea6adc